import { render, staticRenderFns } from "./FabMenuCrud.vue?vue&type=template&id=2634be1e&scoped=true&"
import script from "./FabMenuCrud.vue?vue&type=script&lang=js&"
export * from "./FabMenuCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634be1e",
  null
  
)

export default component.exports